import styled from "styled-components";

const SlideWrap = styled.div`
	position: relative;
	width: 720px;
`;

export default SlideWrap;
